/**
 * @copyright NIIT Technologies Ltd. 2017-18.
 */
// Angular
import { NgModule, NgZone, Component, ElementRef, Renderer, Input, forwardRef, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
// Core
import { ControlComponent } from '../../core/component/control.component';
// JQX Widget
import { jqxNotificationComponent } from 'jqwidgets-framework/jqwidgets-ts/angular_jqxnotification';

/**
 * Notification
 */

export class NgcNotificationComponent extends ControlComponent {
     appendContainer: any;
     autoOpen: any;
     animationOpenDelay: any;
     animationCloseDelay: any;
     autoClose: any;
     autoCloseDelay: any;
     blink: any;
     browserBoundsOffset: any;
     closeOnClick: any;
     disabled: any;
     hoverOpacity: any;
     icon: any;
     notificationOffset: any;
     opacity: any;
     position: any;
     rtl: any;
     showCloseButton: any;
     template: any;
     theme: any;
     width: any;
     height: any;
     autoCreate: boolean = true;

     jqxNotification: jqxNotificationComponent;

    /**
     * Initialize
     */
    constructor(private ngZone: NgZone, private elementRef: ElementRef, private rendererRef: Renderer) {
        super(ngZone, elementRef, rendererRef);
    }
    
    open() {
        this.jqxNotification.open();
    }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
    selector: 'ngc-notification',
    template: `<jqxNotification #jqxNotification
                [appendContainer] = "appendContainer"
                [autoOpen] = "autoOpen"
                [animationOpenDelay] = "animationOpenDelay"
                [animationCloseDelay] = "animationCloseDelay"
                [autoClose] = "autoClose"
                [autoCloseDelay] = "autoCloseDelay"
                [blink] = "blink"
                [browserBoundsOffset] = "browserBoundsOffset"
                [closeOnClick] = "closeOnClick"
                [disabled] = "disabled"
                [hoverOpacity] = "hoverOpacity"
                [icon] = "icon"
                [notificationOffset] = "notificationOffset"
                [opacity] = "opacity"
                [position] = "position"
                [rtl] = "rtl"
                [showCloseButton] = "showCloseButton"
                [template] = "template"
                [theme] = "theme"
                [width] = "width"
                [height] = "height">
                <ng-content></ng-content>
                </jqxNotification>`
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: NgZone, },
{type: ElementRef, },
{type: Renderer, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'appendContainer': [{ type: Input, args: ['appendContainer', ] },],
'autoOpen': [{ type: Input, args: ['autoOpen', ] },],
'animationOpenDelay': [{ type: Input, args: ['animationOpenDelay', ] },],
'animationCloseDelay': [{ type: Input, args: ['animationCloseDelay', ] },],
'autoClose': [{ type: Input, args: ['autoClose', ] },],
'autoCloseDelay': [{ type: Input, args: ['autoCloseDelay', ] },],
'blink': [{ type: Input, args: ['blink', ] },],
'browserBoundsOffset': [{ type: Input, args: ['browserBoundsOffset', ] },],
'closeOnClick': [{ type: Input, args: ['closeOnClick', ] },],
'disabled': [{ type: Input, args: ['disabled', ] },],
'hoverOpacity': [{ type: Input, args: ['hoverOpacity', ] },],
'icon': [{ type: Input, args: ['icon', ] },],
'notificationOffset': [{ type: Input, args: ['notificationOffset', ] },],
'opacity': [{ type: Input, args: ['opacity', ] },],
'position': [{ type: Input, args: ['position', ] },],
'rtl': [{ type: Input, args: ['rtl', ] },],
'showCloseButton': [{ type: Input, args: ['showCloseButton', ] },],
'template': [{ type: Input, args: ['template', ] },],
'theme': [{ type: Input, args: ['theme', ] },],
'width': [{ type: Input, args: ['width', ] },],
'height': [{ type: Input, args: ['height', ] },],
'autoCreate': [{ type: Input, args: ['auto-create', ] },],
'jqxNotification': [{ type: ViewChild, args: ['jqxNotification', ] },],
};
}

/**
 * Notification Module
 */

export class NgcNotificationModule {
static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
    imports: [CommonModule],
    exports: [NgcNotificationComponent],
    declarations: [NgcNotificationComponent, jqxNotificationComponent]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}
interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
